var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2243_36228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7201 5.52545L6.12514 10.1204C5.56222 10.6834 4.79874 10.9996 4.00265 10.9996C3.20655 10.9996 2.44307 10.6834 1.88014 10.1204C1.31722 9.55753 1.00098 8.79404 1.00098 7.99795C1.00098 7.20186 1.31722 6.43837 1.88014 5.87545L6.47514 1.28045C6.85043 0.905167 7.35942 0.694336 7.89014 0.694336C8.42087 0.694336 8.92986 0.905167 9.30515 1.28045C9.68043 1.65573 9.89126 2.16472 9.89126 2.69545C9.89126 3.22618 9.68043 3.73517 9.30515 4.11045L4.70514 8.70545C4.5175 8.89309 4.26301 8.9985 3.99764 8.9985C3.73228 8.9985 3.47779 8.89309 3.29014 8.70545C3.1025 8.51781 2.99709 8.26331 2.99709 7.99795C2.99709 7.73258 3.1025 7.47809 3.29014 7.29045L7.53514 3.05045",
    stroke: "#666666",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2243_36228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.ad2475789eae2a4a6b73827af6fca532.svg";
export { ForwardRef as ReactComponent };